import React, { useCallback } from 'react';

import { Button } from '@swyftx/aviary/atoms/Button';
import { ExternalLink } from '@swyftx/aviary/icons/outlined';
import { ShopItemVariant } from '@swyftx/features/shop/api/types';

type Props = {
  shopItemVariant: ShopItemVariant;
};

const BuyViaLedgerButton: React.FC<Props> = ({ shopItemVariant }) => {
  const openShopItemExternal = useCallback(() => {
    window.open(
      `${shopItemVariant.url}`,
      '_blank',
      'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes, width=1024, height=768, noopener, noreferrer',
    );
  }, [shopItemVariant.url]);

  return (
    <Button color='primary' onClick={openShopItemExternal} size='lg' trailingIcon={<ExternalLink />} className='w-full'>
      Buy via Ledger.com
    </Button>
  );
};

export { BuyViaLedgerButton };
